import { AppShell } from '../shell/AppShell.js';

export function App() {
  return <AppShell />;
}
